import { isAdministrateur, isAxianGroup, isAxianTelecom } from "../../request/Request";
import { Link, useNavigate } from "react-router-dom";
function Navigation() {
    let podcast = (<div></div>);
    let evenement = (<div></div>);
    if (isAxianGroup() || isAdministrateur()) {
        podcast = (
            <li className="nav-item ">
                <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-podcast"}>
                    <i className="bi bi-mic"></i>
                    <span>Podcasts</span>
                </Link>
            </li>
        );
        if (!isAxianTelecom()) {
            evenement = (
                <li className="nav-item ">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-evenement"}>
                        <i className="bi bi-calendar-event"></i>
                        <span>Évènements</span>
                    </Link>
                </li>
            );
        }
    }

    const navigate = useNavigate();

    const logout = () => {
        localStorage.clear();
        window.location.href = process.env.REACT_APP_ADMIN_URL + '/';
    };

    let utilisateur = (<div></div>);
    let abonnee = (<div></div>);
    let theme = (<div></div>);
    let entite = (<div></div>);



    if (isAdministrateur()) {
        utilisateur = (
            <li className="nav-item">
                <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-utilisateur"}>
                    <i className="bi bi-person"></i>
                    <span>Utilisateurs</span>
                </Link>
            </li>
        );
        abonnee = (
            <>
                <li className="nav-item">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-abonnee"}>
                        <i className="bi bi-people"></i>
                        <span>Abonnés</span>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/automatisations"}>
                        <i className="bx bx-bot"></i>
                        <span>Rapport automatique</span>
                    </Link>
                </li>
            </>
        );

        entite = (
            <li className="nav-item">
                <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-entite"}>
                    <i className="bi bi-people"></i>
                    <span>Entités</span>
                </Link>
            </li>
        );

        if (!isAxianTelecom()) {
            theme = (
                <li className="nav-item">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-theme"}>
                        <i className="bx bx-category-alt"></i>
                        <span>Thèmes</span>
                    </Link>
                </li>
            );
        }
    }

    return (
        <aside id="sidebar" className="sidebar">
            <ul className="sidebar-nav" id="sidebar-nav">
                <li className="nav-item">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/dashboard"}>
                        <i className="bx bxs-dashboard"></i>
                        <span>Tableau de bord</span>
                    </Link>
                </li>
                <li className="nav-item ">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-communique"}>
                        <i className="bi bi-newspaper"></i>
                        <span>Actualités</span>
                    </Link>
                </li>
                {evenement}
                <li className="nav-item">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-photo"}>
                        <i className="bx bx-photo-album"></i>
                        <span>Photothèque</span>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-video"}>
                        <i className="bx bx-video"></i>
                        <span>Vidéothèque</span>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-categorie-media"}>
                        <i className="bx bx-category"></i>
                        <span>Catégorie</span>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-document"}>
                        <i className="bx bxs-file-doc"></i>
                        <span>Documents</span>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-podcast"}>
                        <i className="bx bxs-microphone"></i>
                        <span>Podcasts</span>
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-Newsletter"}>
                        <i className="bx bxs-envelope"></i>
                        <span>Newsletters</span>
                    </Link>
                </li>

                {theme}
                {entite}
                {utilisateur}
                <li className="nav-item">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/list-contact"}>
                        <i className="bi bi-envelope"></i>
                        <span>Contact</span>
                    </Link>
                </li>
                {abonnee}
                {isAdministrateur() ? <li className="nav-item">
                    <Link className="nav-link collapsed" to={process.env.REACT_APP_ADMIN_URL + "/history"}>
                        <i className="bx bx-history"></i>
                        <span>Historique</span>
                    </Link>
                </li> : <div></div>}
                <li className="nav-item" onClick={logout}>
                    <span className="nav-link collapsed" >
                        <i className="bi bi-box-arrow-in-right"></i>
                        <span>Déconnecter</span>
                    </span>
                </li>

            </ul>
        </aside>
    );
}

export default Navigation;